export const GET_PAYMENT = 'sagas/payment/GET_PAYMENT'
export const FILL_PAYMENT = 'sagas/payment/FILL_PAYMENT'
export const CREATE_PAYMENT = 'sagas/payment/CREATE_PAYMENT'
export const GET_TASKS_ATTRIBUTES = 'sagas/payment/GET_TASKS_ATTRIBUTES'
